import Image from "next/image";
import Link from "next/link";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

// host.konakla.co tanıtım banner'ı. Anasayfa (SSS altı) ve for-hosts
// (Abonelik Paketleri altı) sayfalarında kullanılıyor.
//
// Layout iki branchli:
// - Mobile (<md): DİKEY akış — içerik (başlık+logo+buton) üstte, görsel altta
//   tam genişlikte. host.png'nin %62'si transparent olduğu için yan yana
//   layout'ta arka plana (turuncu) bakıyor; dikey layout'ta görsel kendi
//   container'ına cover ile fit eder, transparent kısımlar overflow'a taşar.
// - Desktop (md+): mevcut yatay layout. Banner geniş olduğu için görsel
//   container'a göre orantılı küçük, transparent zone'lar fark edilmez.
export function HostBanner() {
  return (
    <section className="px-4 py-8 md:px-6 md:py-16 lg:px-8">
      <div className="mx-auto max-w-5xl">
        <div className="relative overflow-hidden rounded-2xl bg-[#fb8500] md:rounded-3xl">
          {/* Mobile: dikey layout (md altında görünür) */}
          <div className="flex flex-col md:hidden">
            <div className="flex flex-col items-center px-5 pt-7 pb-3 text-center">
              <h2 className="text-xl leading-snug font-bold text-white">
                <span className="block">Uçtan uca kısa süreli</span>
                <span className="block">konaklama yönetimi</span>
              </h2>

              <Image
                src="/host_logo.png"
                alt="konakla host"
                width={200}
                height={67}
                className="mt-4 h-14 w-auto"
              />

              <Link
                href="https://host.konakla.co"
                target="_blank"
                rel="noopener noreferrer"
                className="mt-4"
              >
                <Button
                  size="default"
                  className="h-9 gap-1.5 bg-white px-4 text-sm text-[#fb8500] hover:bg-white/90"
                >
                  Daha Fazla Bilgi
                  <ArrowRight className="h-4 w-4" />
                </Button>
              </Link>
            </div>

            {/* Görsel banner alt yarısı full width. host.png içeriği vertical
                orta-üstte (y=180-560 of 1000), object-[center_25%] ile üst kısmı
                container'a hizalanır → laptop+phone üst kasaları visible, alt
                transparent zone container dışına taşar. h-40 görsel için yeterli
                dikey alan sağlar. */}
            <div className="relative h-40 w-full">
              <Image
                src="/host.png"
                alt="konakla host"
                fill
                sizes="100vw"
                className="object-cover object-[center_25%]"
              />
            </div>
          </div>

          {/* Desktop: yatay layout (md ve üstü) */}
          <div className="relative hidden aspect-[7/2] md:block">
            {/* Sağ — host.png */}
            <div className="absolute top-0 right-0 bottom-0 w-2/5">
              <Image
                src="/host.png"
                alt="konakla host"
                fill
                sizes="40vw"
                className="object-cover object-right"
              />
            </div>

            {/* Sol — başlık + logo + buton */}
            <div className="absolute inset-0 flex items-center">
              <div className="w-3/5 px-16 lg:px-20">
                <h2 className="max-w-lg text-2xl leading-tight font-bold text-white lg:text-3xl">
                  Uçtan uca kısa süreli konaklama yönetimi
                </h2>

                <Image
                  src="/host_logo.png"
                  alt="konakla host"
                  width={200}
                  height={67}
                  className="mt-3 -ml-3 h-14 w-auto lg:-ml-4 lg:h-16"
                />

                <Link
                  href="https://host.konakla.co"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-3 inline-block lg:mt-4"
                >
                  <Button
                    size="default"
                    className="h-10 gap-2 bg-white px-5 text-sm text-[#fb8500] hover:bg-white/90 lg:h-11 lg:px-6"
                  >
                    Daha Fazla Bilgi
                    <ArrowRight className="h-4 w-4" />
                  </Button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
